import React, { useState, useCallback, useMemo } from 'react';

const AccordionContext = React.createContext({
  openItemKey: null,
  toggleOpenItem: () => void 0
});
const Accordion = ({ children }) => {
  const [openItemKey, setOpenItem] = useState(null);
  const toggleOpenItem = useCallback((key) => {
    if (key === openItemKey) {
      setOpenItem(null);
      return;
    }
    setOpenItem(key);
  }, [openItemKey, setOpenItem]);
  const keyedChildren = useMemo(() => React.Children.map(children, (child, index) => {
    if (!React.isValidElement(child)) {
      return;
    }
    return React.cloneElement(child, { itemKey: index });
  }), [children]);
  return /* @__PURE__ */ React.createElement(AccordionContext.Provider, {
    value: { openItemKey, toggleOpenItem }
  }, keyedChildren);
};
Accordion.displayName = "Accordion";

export { Accordion, AccordionContext };
//# sourceMappingURL=Accordion.es.js.map
